import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_have_work_areas_risk_heat_cold'

export const dataPointDefinition = {
  retracedId: 'does_facility_have_work_areas_risk_heat_cold',
  name: 'Does the facility have any work areas with risk of heat or cold stress (extreme hot or cold temperature areas)?',
  description:
    'Heat or cold related stress can occur when the body is unable to warm or cool itself. Heat stress results from a combination of (1) internal body heat production from doing work and (2) external heat exposure from the environment. Cold stress results from being exposed to extreme cold or working in ',
  meta: {
    slcpMeta: {
      key: 'hs-wor-17',
      number: 'HS-WOR-28',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-17', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31620,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
